import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-modal-partners-not-return-orders-message',
  templateUrl: './modal-partners-not-return-orders-message.component.html',
  styleUrls: ['./modal-partners-not-return-orders-message.component.scss']
})
export class ModalPartnersNotReturnOrdersMessageComponent {
  @Output() agreeEvent: EventEmitter<any> = new EventEmitter();

  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;

  show() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }

  agree() {
    this.agreeEvent.emit();
    this.closeModal();
  }

  closeModal() {
    this.isModalShow = false
    this.isDarkBackground = false;
  }
}
